<loading *ngIf="loader" type="kpi"></loading>
<div class="container widget-container">
  <div class="d-flex justify-content-center align-items-center" *ngIf="!selectedDesign">
    <!-- Old Donut -->
    <div class="donut-container" *ngIf="chartData">
      <app-donut-chart [data]="chartData" [donutWidth]="donutWidth" [dataColumn]="'data'" [colorColumn]="'color'"
        [newDesign]="false">
      </app-donut-chart>

    </div>

    <!-- Old Headings -->
    <div style="margin-block: auto; position: relative;text-align: left;white-space: nowrap;"
      class="align-items-center mx-3">
      <div style="display: inline-flex;font-family: 'Poppins';gap:6px">
        <span class="Percentage">{{ headPercentage || '0%' }}</span>
        <span class="ratio">{{ headRatio || '(0/0)' }}</span>
      </div>
      <div class="headHead">
        <span class="heading">{{ this.item.config?.['kpi_heading'] || 'KPI Heading' }}</span><br>
      </div>
      <div class="headHead">
        <span class="subheading">({{ subHeading }})</span>
      </div>
    </div>

    <!-- Old Legend -->
    <div *ngIf="!this.table_view" style="white-space: nowrap;text-align: left;font-family: 'Poppins';">
      <div *ngFor="let i of data">
        <span [style.background-color]="i.color" class="dot"></span>
        <span style="font-family: 'Poppins';font-size: 12px;" class="pl-1">{{ i.name }}</span>:
        <span style="font-weight: bold;font-family: 'Poppins';font-size: 12px;">{{ i.value }}</span>
      </div>
    </div>

    <div *ngIf="this.table_view"
      style="white-space: nowrap; display: grid;grid-template-columns: auto auto;grid-template-rows: auto auto;grid-gap: 0 10px;align-content: center;grid-auto-flow: row;">
      <div class="d-flex justify-content-between align-items-center" *ngFor="let i of data">
        <span class="d-flex align-items-center mr-1">
          <span [style.background-color]="i.color" class="dot"></span>
          <span style="font-family: 'Poppins';font-size: 12px;" class="pl-1">{{ i.name }}</span>
        </span>
        <span style="font-weight: bold;font-family: 'Poppins';font-size: 12px;">{{ i.value }}</span>
      </div>
    </div>
  </div>

  <!-- New Design -->
  <div *ngIf="selectedDesign" class="new-donut-card">
    <div class="donut-center">
      <app-donut-chart [data]="newDesignData" [donutWidth]="donutWidth" [dataColumn]="'value'" [colorColumn]="'color'"
        [newDesign]="true" [donutNewCenterText]="donutNewCenterText">
      </app-donut-chart>

      <!-- <div class="donut-text">
        <div class="donut-value">{{ headPercentage || '0%' }}</div>
        <div class="donut-label">Accuracy</div>
      </div> -->
    </div>

    <div class="new-kpi-info">
      <div class="new-heading">{{ item.config?.['kpi_heading'] || 'Data Accuracy' }}</div>
      <div class="new-subheading" *ngFor="let i of data" [style.display]="i.showInchart ? 'flex' : 'none'">
        {{i.name}}: {{ i.value > 0 && i.value < (0.1) ? '<0.1%' : (i.value ? i.value.toFixed(1) + '%' : '0%')}}
      </div>

      <!-- Correct Legend -->
      <div class="legend-grid">
        <div *ngFor="let i of data" class="legend-item" [style.display]="i.showInchart ? 'none' : 'flex'">
          <span class="dot" [style.background-color]="i.color"></span>
          <span class="legend-label">{{ i.name }}:</span>
          <span class="legend-value">
            {{ i.value > 0 && i.value < (0.1) ? '<0.1%' : (i.value ? i.value.toFixed(1) + '%' : '0%') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Top Right Info -->
<div class="large-icon-containter" *ngIf="item.config" id="setting">
  <img class="info_img" matTooltip="Help" (click)="getInfoDetail()" [matMenuTriggerFor]="info" type="button"
    src="./../../../../assets/svgIcons/info_circle.svg" />
  <mat-menu #info="matMenu">
    <div class="card" style="min-width: 300px;border: none;width: auto;" (click)="$event.stopPropagation()">
      <div class="card-header d-flex justify-content-between align-items-center"
        style="border-bottom: none;background: #ddd;">
        <span style="font-weight: 600;">{{infoData?.info_header}}</span>
        <span (click)="closeMenu()" mat-dialog-close>✖</span>
      </div>
      <div class="card-body">
        <div [innerHtml]="(infoData?.info_text) || '' "></div>
      </div>
    </div>
  </mat-menu>
</div>